export function convertObjToUrl(obj){
    const { 
      sex, 
      faceColor, 
      earSize, 
      eyeStyle, 
      noseStyle, 
      mouthStyle, 
      shirtStyle, 
      shirtColor, 
      glassesStyle, 
      hairStyle, 
      hairColor,
      hatStyle,
      hatColor,
      bgColor,
    } = obj
    const url = `http://sensai.com?sex=${sex}&faceColor=${faceColor}&earSize=${earSize}&eyeStyle=${eyeStyle}&noseStyle=${noseStyle}&mouthStyle=${mouthStyle}&shirtStyle=${shirtStyle}&shirtColor=${shirtColor}&glassesStyle=${glassesStyle}&hairStyle=${hairStyle}&hairColor=${hairColor}&hatStyle=${hatStyle}&hatColor=${hatColor}&bgColor=${bgColor}`
    return url
  }

export function convertUrlToObj(url){
  const params = new URLSearchParams(url)
  const obj = {
      sex: params.get('sex') || 'man', 
      faceColor: params.get('faceColor') || '#d4aa78', 
      earSize: params.get('earSize') || 'small', 
      eyeStyle: params.get('eyeStyle') || 'smile', 
      noseStyle: params.get('noseStyle') || 'round', 
      mouthStyle: params.get('mouthStyle') || 'peace', 
      shirtStyle: params.get('shirtStyle') || 'polo', 
      shirtColor: params.get('shirtColor') || '#fff', 
      glassesStyle: params.get('glassesStyle') || 'none', 
      hairStyle: params.get('hairStyle') || 'normal', 
      hairColor: params.get('hairColor') || '#000',
      hatStyle: params.get('hatStyle') || 'none',
      hatColor: params.get('hatColor') || '#000',
      bgColor: params.get('bgColor') || '#f3f3',
  }
  return obj
}